/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Dropdown_Windows_Arm64Inputs */

const en_downloads_dropdown_windows_arm64 = /** @type {(inputs: Downloads_Dropdown_Windows_Arm64Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows ARM64`)
};

const es_downloads_dropdown_windows_arm64 = /** @type {(inputs: Downloads_Dropdown_Windows_Arm64Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows ARM64`)
};

/**
* | output |
* | --- |
* | "Windows ARM64" |
*
* @param {Downloads_Dropdown_Windows_Arm64Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_dropdown_windows_arm64 = /** @type {((inputs?: Downloads_Dropdown_Windows_Arm64Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Dropdown_Windows_Arm64Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_dropdown_windows_arm64(inputs)
	return en_downloads_dropdown_windows_arm64(inputs)
});